import React, { memo } from "react";
import GroupPreview from "./group_preview";
import GroupsListHeader from "./groups_list_header";
import styled from "styled-components";

const GroupsListWrapper = styled.div`
  position: relative;
  flex: 1;
  padding-top: 38px;
  height: max-content;
  margin: 0 auto;
`;

const GroupsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 66px;
  padding-bottom: 120px;
  overflow: auto;
  max-height: calc(100vh - 190px);

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #fff;
  }
`;

const GroupsList = () => {
  return (
    <GroupsListWrapper>
      <GroupsListHeader />
      <GroupsListContainer>
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
        <GroupPreview />
      </GroupsListContainer>
    </GroupsListWrapper>
  );
};

export default memo(GroupsList);
